<template>
  <div class="w-full border border-gray-300 rounded-lg p-3 bg-white shadow-md mt-3">
    <div v-if="title" class="flex flex-row w-full text-blue font-bold">{{ title }}</div>
    <p v-if="subtitle" class="text-gray-400 text-sm mb-2">{{ subtitle }}</p>
    <legend-document-form
      @epc-add-legend="(legend) => { $emit('epc-add-legend', legend) }"
    />

    <legend-document-list
      :legends="legends"
      @epc-delete-legend="(index) => { $emit('epc-delete-legend', index) }"
    />
  </div>
</template>

<script>
import legendDocumentForm from './legend-document-form.vue';
import legendDocumentList from './legend-document-list.vue';

export default {
  name: "leyend-document-panel",

  components: {
    legendDocumentForm,
    legendDocumentList
  },

  props: {
    legends: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: null
    },
    subtitle: {
      type: String,
      default: null
    },
  },

  data() {
    return {

    };
  },

  methods: {

  }
}
</script>